module.exports = "/_next/static/images/7a4d99346864341f9d648fda43221f6b-girl-holding-card-landing@md.jpg.webp";